import utils from '@/mixins/utils'

export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedFilterBoasPraticas
) {
  let cadastros_filtrados = cadastros

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    if (exibirVermelhos === true) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (item.total_bp < 100) {
          item.rowColor = 'red'
          return true
        }
        return false
      })
    } else if (exibirVerdes === true) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (item.total_bp == 100) {
          item.rowColor = 'green'
          return true
        }
        return false
      })
    } else {
      // caso neutro: sem filtro ativo → todos passam com a cor correspondente
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (item.total_bp == 100) {
          item.rowColor = 'green'
        } else {
          item.rowColor = 'red'
        }
        return true
      })
    }
  } else {
    cadastros_filtrados = filterByBoaPratica(
      cadastros_filtrados,
      selectedFilterBoasPraticas,
      exibirVermelhos,
      exibirVerdes
    )
  }

  return cadastros_filtrados
}

function filterByBoaPratica(cadastros, bp, exibirVermelhos, exibirVerdes) {
  const regras = {
    consultas: { campo: 'a_pb' },
    'peso-altura': { campo: 'b_pb' },
    visitas: { campo: 'c_pb', regraExtra: (el) => el.tp_ine_fci !== '76' },
    vacinas: { campo: 'd_pb' },
  }

  const regra = regras[bp?.key]
  if (!regra) return cadastros

  return cadastros.filter((el) => {
    const valor = Number(el?.[regra.campo])

    // aplica regra extra de "visitas"
    if (regra.regraExtra && !regra.regraExtra(el)) {
      return false
    }

    // vermelho
    if (exibirVermelhos) {
      if (valor == null || valor === 0) {
        el.rowColor = 'red'
        return true
      }
      return false
    }

    // verde
    if (exibirVerdes) {
      if (valor != null && valor > 0) {
        el.rowColor = 'green'
        return true
      }
      return false
    }

    // neutro: considera válido se valor > 0
    if (valor != null && valor > 0) {
      el.rowColor = 'green'
      return true
    }

    el.rowColor = 'red'
    return true
  })
}
